import { ContextPack } from "@/api/studio/contexts/types/context.type";
import { Button } from "@/components/ui/button";

/* Prop Types */
interface ContextDropzoneNavbarProps {
  contextName: string;
  contextPack: ContextPack;
  previous: () => void;
  next: (isPublish: boolean) => void;
  assetIndex: number;
  nextDisabled: boolean;
  previousDisabled: boolean;
}

/*
 * ContextDropzoneNavbar component
 */
export const ContextDropzoneNavbar = ({ contextName, contextPack, previous, next, assetIndex, nextDisabled, previousDisabled }: ContextDropzoneNavbarProps) => {
  /* Render */
  return (
    <>
      <h1 className="truncate max-w-[80vw]">{contextName}</h1>
      <div className="flex gap-2">
        {assetIndex > 0 && (
          <Button variant="ghost" onClick={previous} disabled={previousDisabled}>
            Previous
          </Button>
        )}
        <p className="flex items-center bg-base-200 rounded-lg px-3 shrink-0">{`${assetIndex + 1} of ${contextPack?.contexts.length}`}</p>
        <Button variant="primary" onClick={() => next(assetIndex === contextPack.contextCount - 1)} disabled={nextDisabled}>
          {assetIndex === contextPack.contextCount - 1 ? "Publish" : "Next"}
        </Button>
      </div>
    </>
  );
};
